module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dictionaryAttributes":{"id":"ID","valueType":"Type","code":"Code","name":"Name","versionedFlag":"Versioned","create":{"hint":"Add new dictionary attribute"}}},"ru":{"dictionaryAttributes":{"id":"ID","valueType":"Тип","code":"Код","name":"Наименование","versionedFlag":"Версии","create":{"hint":"Новый атрибут справочника"}}}}')
  delete Component.options._Ctor
}
